import { Texts, Media } from "../../Object";
import { Grid, Space } from '../index'

const QA = (props) => {
  const length = Number(props.length);
  const slug = String(props.slug);
  
  const Item = (props) => {
    const index = props.index;
    
    const Question = () => {
      return(
        <>
          <div className="c-qa__wrap--inner">
            <p className="c-text__section-title c-text--bold c-text--main c-text--en">Q</p>
            <Texts class="c-qa__wrap--inner__text c-text--bold" slug={`${slug}/q${props.index}`}></Texts>
          </div>
        </>
      )
    }
    
    const Answer = () => {
      return(
        <>
          <div className="c-qa__wrap--inner">
            <p className="c-text__section-title c-text--bold c-text--en c-qa__text--answer">A</p>
            <Texts class="c-qa__wrap--inner__text" slug={`${slug}/a${props.index}`}></Texts>
          </div>
        </>
      )
    }
    
    return(
      <>
        <div className="c-qa__wrap">
          <Question></Question>
          <Space size={['24px 0 0', '18px 0 0']}>
            <Answer></Answer>
          </Space>
        </div>
      </>
    )
    
    
  }
  
  let items = [];
  for (let i = 0; i < length; i++) {
    items.push(<Item key={i} index={i}></Item>)
  }
  

  const gridProps = {
    list: {
      dir: ['row'],
      layout: ['100%'],
      size: ['100%'],
      gap: ['40px']
    }
  }
  
  return(
    <>
      <Grid {...gridProps.list}>
        { items }
      </Grid>
    </>
  )
}

export default QA;